/* eslint-disable no-undef */
import ViewDocuments from "../../../../../components/modules/Documents/ViewDocuments";
import Navigation from "../../../../../components/navigations/finance/cases/detail/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";

export default () => {
  const { _case } = useParentLoaderData();
  return (
    <Navigation activeTab="documents" _case={_case}>
      <div className="h-[calc(100vh-12rem)] overflow-y-auto p-4">
        <ViewDocuments customBaseDetailPath={""}/>
      </div>
    </Navigation>
  );
};
